import { render, staticRenderFns } from "./PerformanceValueManagement.vue?vue&type=template&id=95c33b5a&scoped=true"
import script from "./PerformanceValueManagement.vue?vue&type=script&lang=js"
export * from "./PerformanceValueManagement.vue?vue&type=script&lang=js"
import style0 from "./PerformanceValueManagement.vue?vue&type=style&index=0&id=95c33b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c33b5a",
  null
  
)

export default component.exports